import Modal from "./Modal";
import { ModalProps } from "./Modal";

export type { ModalProps };

export default Modal;
